<div class="share-email-dialog-component gap-16" fxLayout="column">
    <div
        fxLayout="row"
        class="share-email-dialog-component__header"
        fxLayoutAlign="space-between center"
    >
        <h1 class="text-16-semi-bold color-text-primary">
            Compartilhar por E-mail
        </h1>
        <dsn-button-menu-chips
            [mainIcon]="'fa-solid fa-xmark'"
            size="medium"
            (onClick)="this.dialogRef.close()"
        ></dsn-button-menu-chips>
    </div>

    <div
        fxLayout="column"
        class="share-email-dialog-component__message"
        fxLayoutAlign="start none"
    >
        <span class="color-text-primary text-14-regular"
            >Envie para usuários cadastrados e/ou para outros contatos.</span
        >
    </div>
    <div
        class="share-email-dialog-component__section gap-16"
        fxFlex
        fxLayout="row"
        fxLayoutAlign="space-between none"
    >
        <div
            class="share-email-dialog-component__column gap-8 full-height"
            fxLayout="column"
            fxFlex="52"
        >
            <app-share-list-select
                [chips]="chips"
                [label]="'Não é usuário? Escreva o e-mail abaixo*'"
                [typeChips]="'email'"
                [placeholderChips]="'Digite o endereço de email'"
                [invalidMessageChips]="
                    'O Email que você digitou esta incorreto.'
                "
                [disableActions]="data.companyId === 'EMPRESA_MODELO'"
                class="full-height"
                style="min-height: 64px"
                [categories]="categories"
                [categoriesSignal]="categoriesSignal"
                (handleContactDialog)="onOpenAddContact($event)"
                (handleUpdateContact)="onUpdateContact($event)"
            ></app-share-list-select>
        </div>
        <div class="share-email-dialog-component__column" fxFlex>
            <app-share-list [ships]="handleChips()"></app-share-list>
        </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="end center" class="gap-12">
        <dsn-button
            [prelabel]="''"
            [label]="'Modelo de mensagem'"
            [type]="'outline'"
            [size]="'medium'"
            [disabled]="loading"
            [iconLeft]="''"
            [iconRight]="''"
            [active]="false"
            [fontWeight]="'bold'"
            [onlyIcon]="''"
            (onClick)="onOpenModelEmailDialog()"
        ></dsn-button>
        <dsn-button
            (onClick)="handleSubmit()"
            [prelabel]="''"
            [label]="'Compartilhar'"
            [type]="'primary'"
            [size]="'medium'"
            [disabled]="loading"
            [iconLeft]="'fa-solid fa-share'"
            [iconRight]="''"
            [active]="false"
            [fontWeight]="'bold'"
            [onlyIcon]="''"
        ></dsn-button>
    </div>
</div>
